// import { useState, useEffect } from "react";
// import { MdClose, MdCheck } from "react-icons/md";
// import { CircularProgress } from "@mui/material";
// import tw from "tailwind-styled-components";
// import { ActionSection, Label, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
// import { GoSearch } from "react-icons/go";

// export default function SelectMultipleRoomModal({
//     isOpen,
//     onClose,
//     onSelect,
//     options = [],
//     selectedItem = [],
//     title = "Select Items",
//     searchPlaceholder = "Search...",
//     emptyMessage = "No items available",
//     noResultsMessage = "No items found",
//     renderItem = null,
//     idKey = "id",
//     nameKey = "name",
//     descriptionKeys = [],
//     enableSearch = true,
//     isLoading = false,
// }) {
//     const [tempSelectedItems, setTempSelectedItems] = useState(Array.isArray(selectedItem) ? selectedItem : []);
//     const [searchText, setSearchText] = useState("");

//     useEffect(() => {
//         if (isOpen) {
//             setTempSelectedItems(Array.isArray(selectedItem) ? selectedItem : []);
//             setSearchText("");
//         }
//     }, [isOpen, selectedItem]);

//     const hasTenants = (item) => {
//         return item.tenantCount > 0;
//     };

//     const handleItemSelect = (item) => {
//         if (!hasTenants(item)) return;

//         const isAlreadySelected = tempSelectedItems.some(selected => selected[idKey] === item[idKey]);
//         let newSelectedItems;

//         if (isAlreadySelected) {
//             newSelectedItems = tempSelectedItems.filter(selected => selected[idKey] !== item[idKey]);
//         } else {
//             newSelectedItems = [...tempSelectedItems, item];
//         }

//         setTempSelectedItems(newSelectedItems);
//     };

//     const handleSelectAll = () => {
//         const availableRooms = filteredOptions.filter(item => hasTenants(item));

//         if (areAllAvailableItemsSelected()) {
//             const availableRoomIds = new Set(availableRooms.map(item => item[idKey]));
//             const newSelectedItems = tempSelectedItems.filter(item => !availableRoomIds.has(item[idKey]));
//             setTempSelectedItems(newSelectedItems);
//         } else {
//             const availableRoomIds = new Set(availableRooms.map(item => item[idKey]));
//             const currentlySelectedIds = new Set(tempSelectedItems.map(item => item[idKey]));

//             const itemsToAdd = availableRooms.filter(item => !currentlySelectedIds.has(item[idKey]));
//             const newSelectedItems = [...tempSelectedItems, ...itemsToAdd];

//             setTempSelectedItems(newSelectedItems);
//         }
//     };

//     const handleApplySelection = () => {
//         onSelect(tempSelectedItems);
//         onClose();
//     };

//     const filteredOptions = options.filter(item =>
//         item[nameKey]?.toLowerCase().includes(searchText.toLowerCase()) ||
//         descriptionKeys.some(key => {
//             if (Array.isArray(key)) {
//                 return key.some(k => item[k]?.toLowerCase().includes(searchText.toLowerCase()))
//             }
//             return item[key]?.toLowerCase().includes(searchText.toLowerCase())
//         })
//     );

//     const getDescriptionValue = (item, key) => {
//         if (Array.isArray(key)) {
//             for (const k of key) {
//                 if (item[k]) return item[k];
//             }
//             return null;
//         }
//         return item[key];
//     };

//     const defaultRenderItem = (item, isSelected) => {
//         const descriptionValues = descriptionKeys
//             .map(key => getDescriptionValue(item, key))
//             .filter(value => value != null && value !== "");

//         const hasTenantsInRoom = hasTenants(item);
//         const tenantCount = item.tenantCount || 0;

//         return (
//             <div className="flex items-center flex-1">
//                 <div className={`w-5 h-5 border-2 rounded mr-3 flex items-center justify-center ${!hasTenantsInRoom
//                     ? 'bg-gray-100 border-gray-300 cursor-not-allowed'
//                     : isSelected
//                         ? 'bg-primary-color border-primary-color'
//                         : 'border-gray-300'
//                     }`}>
//                     {isSelected && hasTenantsInRoom && <MdCheck className="text-white" size={14} />}
//                     {!hasTenantsInRoom && <div className="w-2 h-2 bg-gray-400 rounded-sm" />}
//                 </div>

//                 <div className="flex flex-col flex-1">
//                     <div className="flex items-center gap-2">
//                         <Label className={`font-medium text-sm ${!hasTenantsInRoom ? 'text-gray-400' : ''}`}>
//                             {item[nameKey]}
//                         </Label>

//                         <span className={`text-xs px-2 py-1 rounded-full ${tenantCount === 0
//                             ? 'bg-gray-100 text-gray-500'
//                             : 'bg-blue-100 text-blue-700'
//                             }`}>
//                             {tenantCount} tenant{tenantCount !== 1 ? 's' : ''}
//                         </span>
//                     </div>
//                     {descriptionValues.length > 0 && (
//                         <div className={`text-xs mt-1 ${!hasTenantsInRoom ? 'text-gray-400' : 'text-gray-500'}`}>
//                             {descriptionValues.map((value, index) => (
//                                 <span key={index}>
//                                     {value}
//                                     {index < descriptionValues.length - 1 && " • "}
//                                 </span>
//                             ))}
//                         </div>
//                     )}
//                 </div>
//             </div>
//         );
//     };
//     const isSelected = (itemId) => {
//         return tempSelectedItems.some(item => item[idKey] === itemId);
//     };

//     const areAllAvailableItemsSelected = () => {
//         const availableRooms = filteredOptions.filter(item => hasTenants(item));
//         if (availableRooms.length === 0) return false;
//         return availableRooms.every(item => isSelected(item[idKey]));
//     };

//     const areSomeAvailableItemsSelected = () => {
//         const availableRooms = filteredOptions.filter(item => hasTenants(item));
//         if (availableRooms.length === 0) return false;
//         return availableRooms.some(item => isSelected(item[idKey]));
//     };

//     const countAvailableRooms = () => {
//         return filteredOptions.filter(item => hasTenants(item)).length;
//     };

//     const countSelectedAvailableRooms = () => {
//         return tempSelectedItems.filter(item => hasTenants(item)).length;
//     };

//     if (!isOpen) return null;

//     return (
//         <Overlay>
//             <ModalWrapper>
//                 <Header>
//                     <div className="flex items-center justify-between w-full">
//                         <h1 className="text-white text-lg font-medium">{title}</h1>
//                         <button onClick={onClose}>
//                             <MdClose color="white" size={24} />
//                         </button>
//                     </div>
//                 </Header>

//                 {enableSearch && (
//                     <div className="p-4 relative">
//                         <div className="relative">
//                             <input
//                                 type="text"
//                                 placeholder={searchPlaceholder}
//                                 value={searchText}
//                                 onChange={(e) => setSearchText(e.target.value)}
//                                 className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
//                             />
//                             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                                 <GoSearch className="w-4 h-4 text-gray-400" />
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 <ScrollableContent >
//                     {isLoading ? (
//                         <div className="flex justify-center py-8">
//                             <CircularProgress />
//                         </div>
//                     ) : filteredOptions.length === 0 ? (
//                         <div className="text-center py-8 text-gray-500">
//                             {options.length === 0 ? emptyMessage : noResultsMessage}
//                         </div>
//                     ) : (
//                         <div className="px-4 space-y-2">
//                             <OptionRow
//                                 onClick={handleSelectAll}
//                                 selected={areAllAvailableItemsSelected()}
//                                 className="bg-gray-50"
//                                 disabled={countAvailableRooms() === 0}
//                             >
//                                 <div className="flex items-center flex-1">
//                                     <div className={`w-5 h-5 border-2 rounded mr-3 flex items-center justify-center ${countAvailableRooms() === 0
//                                         ? 'bg-gray-100 border-gray-300 cursor-not-allowed'
//                                         : areAllAvailableItemsSelected()
//                                             ? 'bg-primary-color border-primary-color'
//                                             : areSomeAvailableItemsSelected()
//                                                 ? 'bg-primary-color border-primary-color opacity-50'
//                                                 : 'border-gray-300'
//                                         }`}>
//                                         {areAllAvailableItemsSelected() && countAvailableRooms() > 0 && <MdCheck className="text-white" size={14} />}
//                                         {areSomeAvailableItemsSelected() && !areAllAvailableItemsSelected() && countAvailableRooms() > 0 && (
//                                             <div className="w-2 h-2 bg-white rounded-sm" />
//                                         )}
//                                         {countAvailableRooms() === 0 && <div className="w-2 h-2 bg-gray-400 rounded-sm" />}
//                                     </div>
//                                     <div className="flex flex-col flex-1">
//                                         <Label className={`font-medium text-sm ${countAvailableRooms() === 0 ? 'text-gray-400' : ''}`}>
//                                             Select All Available Rooms
//                                         </Label>
//                                         <div className="text-xs text-gray-500 mt-1">
//                                             {countAvailableRooms() === 0
//                                                 ? 'No rooms with tenants available'
//                                                 : areAllAvailableItemsSelected()
//                                                     ? `All ${countAvailableRooms()} available rooms selected`
//                                                     : `Select all ${countAvailableRooms()} available rooms`
//                                             }
//                                         </div>
//                                     </div>
//                                 </div>
//                             </OptionRow>

//                             {filteredOptions.map((item) => {
//                                 const itemSelected = isSelected(item[idKey]);
//                                 const hasTenantsInRoom = hasTenants(item);

//                                 return (
//                                     <OptionRow
//                                         key={item[idKey]}
//                                         onClick={() => handleItemSelect(item)}
//                                         selected={itemSelected}
//                                         disabled={!hasTenantsInRoom}
//                                     >
//                                         {renderItem ?
//                                             renderItem(item, itemSelected) :
//                                             defaultRenderItem(item, itemSelected)
//                                         }
//                                     </OptionRow>
//                                 );
//                             })}
//                         </div>
//                     )}
//                 </ScrollableContent>

//                 <ActionSection>
//                     <SideCancelBtn
//                         type="button"
//                         onClick={() => {
//                             onClose();
//                         }}
//                     >
//                         Cancel
//                     </SideCancelBtn>

//                     <SubmitBtn
//                         type="button"
//                         onClick={handleApplySelection}
//                         disabled={tempSelectedItems.length === 0}
//                     >
//                         Apply ({countSelectedAvailableRooms()})
//                     </SubmitBtn>
//                 </ActionSection>
//             </ModalWrapper>
//         </Overlay>
//     );
// }

// const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`;
// const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative`;
// const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
// const OptionRow = tw.div`
//     flex items-center justify-between p-4 border border-gray-200 rounded-lg cursor-pointer
//     ${props => props.disabled
//         ? 'bg-gray-50 cursor-not-allowed opacity-60'
//         : props.selected
//             ? 'border-primary-color bg-blue-50 hover:bg-blue-100'
//             : 'hover:bg-gray-50'
//     }
// `;

import { useState, useEffect } from "react";
import { MdClose, MdCheck } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { ActionSection, Label, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import { GoSearch } from "react-icons/go";

export default function SelectMultipleRoomModal({
    isOpen,
    onClose,
    onSelect,
    options = [],
    selectedItem = [],
    title = "Select Items",
    searchPlaceholder = "Search...",
    emptyMessage = "No items available",
    noResultsMessage = "No items found",
    renderItem = null,
    idKey = "id",
    nameKey = "name",
    descriptionKeys = [],
    enableSearch = true,
    isLoading = false,
}) {
    const [tempSelectedItems, setTempSelectedItems] = useState(Array.isArray(selectedItem) ? selectedItem : []);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (isOpen) {
            setTempSelectedItems(Array.isArray(selectedItem) ? selectedItem : []);
            setSearchText("");
        }
    }, [isOpen, selectedItem]);

    const handleItemSelect = (item) => {
        const isAlreadySelected = tempSelectedItems.some(selected => selected[idKey] === item[idKey]);
        let newSelectedItems;

        if (isAlreadySelected) {
            newSelectedItems = tempSelectedItems.filter(selected => selected[idKey] !== item[idKey]);
        } else {
            newSelectedItems = [...tempSelectedItems, item];
        }

        setTempSelectedItems(newSelectedItems);
    };

    const handleSelectAll = () => {
        const allRooms = filteredOptions;

        if (areAllItemsSelected()) {
            setTempSelectedItems([]);
        } else {
            const allRoomIds = new Set(allRooms.map(item => item[idKey]));
            const currentlySelectedIds = new Set(tempSelectedItems.map(item => item[idKey]));

            const itemsToAdd = allRooms.filter(item => !currentlySelectedIds.has(item[idKey]));
            const newSelectedItems = [...tempSelectedItems, ...itemsToAdd];

            setTempSelectedItems(newSelectedItems);
        }
    };

    const handleApplySelection = () => {
        onSelect(tempSelectedItems);
        onClose();
    };

    const filteredOptions = options.filter(item =>
        item[nameKey]?.toLowerCase().includes(searchText.toLowerCase()) ||
        descriptionKeys.some(key => {
            if (Array.isArray(key)) {
                return key.some(k => item[k]?.toLowerCase().includes(searchText.toLowerCase()))
            }
            return item[key]?.toLowerCase().includes(searchText.toLowerCase())
        })
    );

    const getDescriptionValue = (item, key) => {
        if (Array.isArray(key)) {
            for (const k of key) {
                if (item[k]) return item[k];
            }
            return null;
        }
        return item[key];
    };

    const defaultRenderItem = (item, isSelected) => {
        const descriptionValues = descriptionKeys
            .map(key => getDescriptionValue(item, key))
            .filter(value => value != null && value !== "");

        const tenantCount = item.tenantCount || 0;

        return (
            <div className="flex items-center flex-1">
                <div className={`w-5 h-5 border-2 rounded mr-3 flex items-center justify-center ${isSelected
                    ? 'bg-primary-color border-primary-color'
                    : 'border-gray-300'
                    }`}>
                    {isSelected && <MdCheck className="text-white" size={14} />}
                </div>

                <div className="flex flex-col flex-1">
                    <div className="flex items-center gap-2">
                        <Label className="font-medium text-sm">
                            {item[nameKey]}
                        </Label>

                        <span className={`text-xs px-2 py-1 rounded-full ${tenantCount === 0
                            ? 'bg-gray-100 text-gray-600'
                            : 'bg-blue-100 text-blue-700'
                            }`}>
                            {tenantCount} tenant{tenantCount !== 1 ? 's' : ''}
                        </span>
                    </div>
                    {descriptionValues.length > 0 && (
                        <div className="text-xs mt-1 text-gray-500">
                            {descriptionValues.map((value, index) => (
                                <span key={index}>
                                    {value}
                                    {index < descriptionValues.length - 1 && " • "}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const isSelected = (itemId) => {
        return tempSelectedItems.some(item => item[idKey] === itemId);
    };

    const areAllItemsSelected = () => {
        if (filteredOptions.length === 0) return false;
        return filteredOptions.every(item => isSelected(item[idKey]));
    };

    const areSomeItemsSelected = () => {
        if (filteredOptions.length === 0) return false;
        return filteredOptions.some(item => isSelected(item[idKey]));
    };

    const countTotalRooms = () => {
        return filteredOptions.length;
    };

    const countSelectedRooms = () => {
        return tempSelectedItems.length;
    };

    if (!isOpen) return null;

    return (
        <Overlay>
            <ModalWrapper>
                <Header>
                    <div className="flex items-center justify-between w-full">
                        <h1 className="text-white text-lg font-medium">{title}</h1>
                        <button onClick={onClose}>
                            <MdClose color="white" size={24} />
                        </button>
                    </div>
                </Header>

                {enableSearch && (
                    <div className="p-4 relative">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder={searchPlaceholder}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
                            />
                            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                <GoSearch className="w-4 h-4 text-gray-400" />
                            </div>
                        </div>
                    </div>
                )}

                <ScrollableContent>
                    {isLoading ? (
                        <div className="flex justify-center py-8">
                            <CircularProgress />
                        </div>
                    ) : filteredOptions.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            {options.length === 0 ? emptyMessage : noResultsMessage}
                        </div>
                    ) : (
                        <div className="px-4 space-y-2">
                            <OptionRow
                                onClick={handleSelectAll}
                                selected={areAllItemsSelected()}
                                className="bg-gray-50"
                            >
                                <div className="flex items-center flex-1">
                                    <div className={`w-5 h-5 border-2 rounded mr-3 flex items-center justify-center ${areAllItemsSelected()
                                        ? 'bg-primary-color border-primary-color'
                                        : areSomeItemsSelected()
                                            ? 'bg-primary-color border-primary-color opacity-50'
                                            : 'border-gray-300'
                                        }`}>
                                        {areAllItemsSelected() && <MdCheck className="text-white" size={14} />}
                                        {areSomeItemsSelected() && !areAllItemsSelected() && (
                                            <div className="w-2 h-2 bg-white rounded-sm" />
                                        )}
                                    </div>
                                    <div className="flex flex-col flex-1">
                                        <Label className="font-medium text-sm">
                                            Select All Rooms
                                        </Label>
                                        <div className="text-xs text-gray-500 mt-1">
                                            {areAllItemsSelected()
                                                ? `All ${countTotalRooms()} rooms selected`
                                                : `Select all ${countTotalRooms()} rooms`
                                            }
                                        </div>
                                    </div>
                                </div>
                            </OptionRow>

                            {filteredOptions.map((item) => {
                                const itemSelected = isSelected(item[idKey]);

                                return (
                                    <OptionRow
                                        key={item[idKey]}
                                        onClick={() => handleItemSelect(item)}
                                        selected={itemSelected}
                                    >
                                        {renderItem ?
                                            renderItem(item, itemSelected) :
                                            defaultRenderItem(item, itemSelected)
                                        }
                                    </OptionRow>
                                );
                            })}
                        </div>
                    )}
                </ScrollableContent>

                <ActionSection>
                    <SideCancelBtn
                        type="button"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Cancel
                    </SideCancelBtn>

                    <SubmitBtn
                        type="button"
                        onClick={handleApplySelection}
                        disabled={tempSelectedItems.length === 0}
                    >
                        Apply ({countSelectedRooms()})
                    </SubmitBtn>
                </ActionSection>
            </ModalWrapper>
        </Overlay>
    );
}

const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`;
const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const OptionRow = tw.div`
    flex items-center justify-between p-4 border border-gray-200 rounded-lg cursor-pointer
    ${props => props.selected
        ? 'border-primary-color bg-blue-50 hover:bg-blue-100'
        : 'hover:bg-gray-50'
    }
`;